
<select v-model="value_" @change="onChange($event)" :class="{search: this.search}" :id="id" :name="name">
  <slot></slot>
  <option v-if="options" v-for="each in options" :key="`${keyPrefix}${each.value}`" :value="each.value">{{ each.label }}</option>

</select>
